import { render } from "./ReportTab.vue?vue&type=template&id=8a3616f8&scoped=true"
import script from "./ReportTab.vue?vue&type=script&lang=js"
export * from "./ReportTab.vue?vue&type=script&lang=js"

import "./ReportTab.vue?vue&type=style&index=0&id=8a3616f8&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8a3616f8"]])

export default __exports__